module.exports = __webpack_public_path__ + "components/rewards/freefloski/static/logo-313ed1b3bf049b1ac143157c1976dae0.webp";